"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeTreeViewStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeTreeViewStyles = function makeTreeViewStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiTreeView: {
      styleOverrides: {
        root: {
          position: "relative",
          "&.DhigTreeView--variant--flat": {
            borderBottom: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["detail-1-opaque"].rgb),
            borderTop: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["detail-1-opaque"].rgb),
            "> .MuiTreeItem-root:first-of-type > div.DhigTreeItem": {
              hr: {
                display: "none"
              }
            },
            "& hr": {
              position: "absolute",
              left: primitives.spacings["0"],
              width: "100%",
              zIndex: 0
            }
          },
          "&.DhigTreeView--size--dense": {
            '& [class*="MuiTreeItem-content"]': {
              padding: primitives.spacings["3"]
            },
            '& [class*="MuiTreeItem-label"]': _objectSpread({}, tokens.typography["short-copy-small"])
          }
        }
      }
    }
  };
};

exports.makeTreeViewStyles = makeTreeViewStyles;